import type { AxiosInstance } from 'axios';

export type ChatwootUnreadApiState = {
  unread_count: number;
  has_unread: boolean;
  last_message_preview?: string | null;
  last_message_at?: string | null;
};

type ApiEnvelope<T> = {
  status: number;
  message: string;
  data: T;
};

export const getChatwootUnread = async (
  axiosprivate: AxiosInstance,
): Promise<ChatwootUnreadApiState> => {
  const res = await axiosprivate.get<ApiEnvelope<ChatwootUnreadApiState>>(
    '/support/chatwoot/unread',
  );

  return res.data.data;
};

export const markChatwootRead = async (
  axiosprivate: AxiosInstance,
): Promise<ChatwootUnreadApiState> => {
  const res = await axiosprivate.post<ApiEnvelope<ChatwootUnreadApiState>>(
    '/support/chatwoot/mark-read',
  );

  return res.data.data;
};
